import React from 'react';
import {Title, Image,  Slideshow} from './../../Basics';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars

const Particle09 = () => (<div>

  <Title>The wheelchairs in the race</Title>

  <Slideshow>
    <section>
      <Image
        source={require('./09_1_WHEEL_Team_RT-Movers_AlessandroDellaBella_102.jpg')}
        title='The fast vehicle'
        caption={
          <span>
            <b>The fast vehicle</b>
            This wheelchair can reach high speeds and climb stairs thanks to its four individually driven wheels.
            Flexible front and rear axles allow for smooth progress on uneven terrain.
            <br/>
            Team: RT Movers, Universität Wakayama, Japan
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_2_WHEEL_Team-HSR-Enhanced_AlessandroDellaBella_040.jpg')}
        title='The rotating vehicle'
        caption={
          <span>
            <b>The rotating vehicle</b>
            Rotating metal pins lift the wheelchair from one step to the next. The pilot’s weight is shifted forward to
                keep the wheelchair from tipping backwards. Four individually controlled wheels make the vehicle
                fast and manoeuvrable.
                <br/>
            Team: HSR Enhanced, Hochschule Rapperswil, Switzerland 
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_3_WHEEL_Team-laddroller_AlessandroDellaBella_039.jpg')}
        title='The manoeuvrable vehicle'
        caption={
          <span>
            <b>The manoeuvrable vehicle</b>
            This vehicle, which allows the pilot to go from a sitting to a standing position, is a combination between an
            exoskeleton and a wheelchair. Its wheels can go forward, backwards and sideways, thus providing high manoeuvrability.
            <br/>
            Team: Laddroller, Greece
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_4_WHEEL_Team_Avalanche_AlessandroDellaBella_104.jpg')}
        title='The variable vehicle'
        caption={
          <span>
            <b>The variable vehicle</b>
            This wheelchair can go sideways and rotate around its own axis. When the terrain becomes impassable for wheels, it
            lowers a special caterpillar drive that also enables it to climb stairs.
            <br/>
            Team: Avalanche, University of Ljubljana, Slovenia
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_5_WHEEL_Team-HKUST-wheels_AlessandroDellaBella_036.jpg')}
        title='The caterpillar vehicle'
        caption={
          <span>
            <b>The caterpillar vehicle</b>
            Thanks to two caterpillars, this wheelchair can deal with difficult terrain as easily as a tank. It can ride over
            small obstacles without difficulty and climb stairs as if they were a ramp.
            <br/>
            Team: HKUST, Hong Kong University of Science and Technology, Hong Kong
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./09_6_WHEEL_Team-HERL-wheels_AlessandroDellaBella_042.jpg')}
        title='The wheelchair on stilts'
        caption={
            <span>
            <b>The wheelchair on stilts</b>
            The MeBot has three pairs of wheels. To overcome an obstacle, it extends the first set of wheels and lifts the vehicle.
            The next pair then comes forward and heaves the wheelchair over the obstacle. Finally, the last set of wheels comes into
            operation.
            <br/>
            HERL MeBot, Human Engineering Research Lab, Pittsburgh, USA
            <br/> 
            Fotos: ETHZ
          </span>
        }
      />
    </section>

  </Slideshow>

  <Particle
    number={2}
  />

  <Particle
    number={3}
  />

</div>);

export default Particle09;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle09/Particle09_EN.js
 **/